import { type FC } from 'react';
import { VStack } from '@direct-frontend/components';
import { type VariantInfo } from '@/shared/api/variants';
import { CharacteristicsList } from '@/shared/components/CharacteristicsList';
import { Drawer, DrawerBottomFixed, DrawerButton, DrawerHeader, type DrawerProps } from '@/shared/components/Drawer';
import type { AnimationState } from '@/shared/lib/animationState';
import { OrderVariantsEditModalEmpty } from './OrderVariantsEditModalEmpty';
import { OrderVariantsEditModalStub } from './OrderVariantsEditModalStub';
import styles from './OrderVariantsEditModal.module.css';

interface OrderVariantsEditModalProps extends Pick<DrawerProps, 'isOpen' | 'onClose'> {
    characteristics: Array<VariantInfo>;
    handleCharacteristicsChange: (characteristic: VariantInfo) => void;
    onSizeTableOpen: VoidFunction;
    sizeTableSrc?: string;
    onSaveVariant: VoidFunction;
    onAnimationEnd?: (animationState: AnimationState) => void;
    stubLength?: number;
}

const OrderVariantsEditModalBody: FC<Omit<OrderVariantsEditModalProps, 'isOpen' | 'onAnimationEnd'>> = ({
    characteristics,
    handleCharacteristicsChange,
    sizeTableSrc,
    onSizeTableOpen,
    onSaveVariant,
    onClose,
    stubLength = 0,
}) => {
    if (stubLength > 0) {
        return <OrderVariantsEditModalStub length={stubLength} />;
    }

    if (!characteristics.length) {
        return <OrderVariantsEditModalEmpty onClose={onClose} />;
    }

    return (
        <>
            <VStack className={styles.scroll}>
                <DrawerHeader title="Уточните выбор" />

                <CharacteristicsList
                    characteristics={characteristics}
                    onCharacteristicsChange={handleCharacteristicsChange}
                    sizeTableSrc={sizeTableSrc}
                    onSizeTableOpen={onSizeTableOpen}
                    isCollapsable
                    isWrappable
                />
            </VStack>

            <VStack className={styles.button}>
                <DrawerBottomFixed isSticky>
                    <DrawerButton onClick={onSaveVariant}>Выбрать</DrawerButton>
                </DrawerBottomFixed>
            </VStack>
        </>
    );
};

export const OrderVariantsEditModal: FC<OrderVariantsEditModalProps> = ({
    isOpen,
    onClose,
    onAnimationEnd,
    ...props
}) => (
    <Drawer snapPoints={[1]} isOpen={isOpen} onClose={onClose} onAnimationEnd={onAnimationEnd}>
        <OrderVariantsEditModalBody onClose={onClose} {...props} />
    </Drawer>
);
